// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"toggle_Toggle__Nk8Gb","on":"toggle_on__LyrUK","circle":"toggle_circle__3fw2x","off":"toggle_off__1QBUj","in":"toggle_in__3IDYw","out":"toggle_out__3W39e"};